// extracted by mini-css-extract-plugin
export default {"Intro":"Intro_Intro__IJnpl","opened":"Intro_opened__kvUy1","closed":"Intro_closed__kG1nQ"};